module.exports = __webpack_public_path__ + "static/media/thumb5.938134ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/thumb5.jpg
// module id = 644
// module chunks = 0